import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@shared/hooks/useAuth';
import {
  fetchUnreadMessages,
  messagesUnreadQueryKey,
  type UnreadMessage,
} from '@shared/hooks/useMessagesCount';
import { resolveHeaderApiError, type HeaderApiError } from './headerApiError';

/**
 * «Оператор разобрал обращение» — общий для всех операторов признак архива.
 *
 * Раньше это поле называлось `is_read`, хотя приезжало из is_archive. Имя врало:
 * «прочитано» — признак ПЕР-ОПЕРАТОРА, и в строке сообщения его нет вовсе (он
 * считается сравнением с отметкой employees_properties.date_last_msg этого
 * оператора). Провод приведён к правде в backend/internal/message/domain/message.go.
 */
export type Message = UnreadMessage;

export function useMessages() {
  const { hasPermission } = useAuth();

  const { data, isLoading, isError, error, refetch } = useQuery({
    // Тот же ключ И та же fetch-функция, что у хука меню (shared/hooks/useMessagesCount.ts) —
    // одна запись кеша на один факт, один объявленный тип формы ответа на обоих концах.
    queryKey: messagesUnreadQueryKey,
    queryFn: fetchUnreadMessages,
    // Гейт обязан быть и здесь: при общем ключе негейченный хук наполнил бы кеш,
    // из которого гейченный отрисовал бы бейдж — гейт одного бесполезен.
    enabled: hasPermission('customers.messages'),
    refetchInterval: 30000, // Обновлять каждые 30 секунд
    retry: false,
  });

  const headerError: HeaderApiError | null = resolveHeaderApiError(error);

  return {
    messages: data?.messages || [],
    unreadCount: data?.unread_count || 0,
    isLoading,
    isError,
    error: headerError,
    refetch,
  };
}

